import React, { useState } from "react";
import { useQuery } from "@apollo/client";
import { GET_TOWERS_QUERY } from "../../graphql/queries/towers";
import Loader from "../../components/loader/loader";
import Table from "../../components/table/table";
import TableCellRenderer from "../../components/table/table-cell-renderer";
import Modal from "../../components/modal/Modal";
import { dateToString } from "../../utils/date-converter";
import TowerModal from "../../components/add-tower/add-tower";
import useUserRoleStore from "../../store/user-role";
import { isAdmin } from "../../utils/roles";

const Grids = () => {
  const [editTowerModal, setEditTowerModal] = useState(false);
  const [selectedTower, setSelectedTower] = useState(null);

  const { data, loading, error } = useQuery(GET_TOWERS_QUERY, {
    variables: {
      first: 10,
      skip: 0,
    },
    fetchPolicy: "network-only",
  });

  const { role } = useUserRoleStore();
  const canEdit = isAdmin(role);

  const onRowClick = (tower) => {
    setSelectedTower(tower);
    setEditTowerModal(true);
  };

  const onEditTowerClose = () => {
    setEditTowerModal(false);
    setSelectedTower(null);
  };

  if (loading) {
    return <Loader sizeClass={"size--medium"} />;
  }

  if (error) {
    return <div className="display-page__error">Something went wrong</div>;
  }

  return (
    <div className="display-page">
      <div className="display-page__title">Grids</div>
      <div className="display-page__table">
        <Table
          data={data?.towers?.items}
          onRowClick={canEdit ? onRowClick : undefined}
          columns={[
            {
              field: "installDate",
              title: "Install Date",
              showOnMobile: true,
              hideMobileUp: false,
              render: ({ installDate }) => {
                return (
                  <TableCellRenderer firstItem={dateToString(installDate)} />
                );
              },
            },
            {
              field: "numberChannels",
              title: "Number of Channels",
              showOnMobile: true,
              hideMobileUp: false,
              render: ({ numberChannels }) => {
                return <TableCellRenderer firstItem={numberChannels} />;
              },
            },
            {
              field: "zonkeId",
              title: "Zonke ID",
              showOnMobile: true,
              hideMobileUp: false,
              render: ({ zonkeId }) => {
                return <TableCellRenderer firstItem={zonkeId} />;
              },
            },
            {
              field: "w3w",
              title: "What3Words",
              showOnMobile: true,
              hideMobileUp: false,
              render: ({ w3w }) => {
                return <TableCellRenderer firstItem={w3w || "--"} />;
              },
            },
            {
              field: "port",
              title: "Port",
              showOnMobile: true,
              hideMobileUp: false,
              render: ({ port }) => {
                return <TableCellRenderer firstItem={port || "--"} />;
              },
            },
            {
              field: "clients",
              title: "Number of Clients",
              showOnMobile: true,
              hideMobileUp: false,
              render: ({ clientSet }) => {
                return <TableCellRenderer firstItem={clientSet?.length || 0} />;
              },
            },
          ]}
        />
      </div>

      <Modal
        modal={editTowerModal}
        onClose={onEditTowerClose}
        modalSize="large"
        showClose={true}
      >
        <TowerModal onCancel={onEditTowerClose} tower={selectedTower} />
      </Modal>
    </div>
  );
};

export default Grids;
